import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {RoleRegistration} from "../../models/role-registration";
import Helpers from "../../utils/helpers";

@Injectable()
export class RoleRegistrationControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getRoleRegistration(roleRegistrationId: string) {
    return this.http.get(this.baseUrl + "role_registration/" + roleRegistrationId);
  }

  public saveRoleRegistration(roleRegistrationId: string, roleRegistration: RoleRegistration) {
    Helpers.trimRecursiveObj(roleRegistration);
    const body = JSON.stringify(roleRegistration);
    return this.http.put(this.baseUrl + "role_registration/" + roleRegistrationId, body, {responseType: "text"});
  }

  public createRoleRegistration(roleId: string, registrationId: string) {
    const body = registrationId;
    return this.http.post(this.baseUrl + "role/" + roleId + "/role_registration", body);
  }

  public createRoleRegistrations(roleId: string, registrationIds: string[]): Observable<RoleRegistration[]> {
    const body = JSON.stringify(registrationIds);
    return this.http.post(this.baseUrl + "role/" + roleId + "/role_registrations", body) as Observable<RoleRegistration[]>;
  }

  public deleteRoleRegistration(roleRegistrationId: string) {
    return this.http.delete(this.baseUrl + "role_registration/" + roleRegistrationId, {responseType: "text"});
  }

}
